module.exports = __webpack_public_path__ + "static/img/client23_img.3b17e8c.png";